export default __webpack_public_path__ + "static/media/bio.74a0d8bc.webp";